import { useEffect, useState } from "react";
import { Button, Alert, Image, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ChevronRight } from "react-bootstrap-icons";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { getClientByClientId } from "../../../../store/actions/clientsAction";
import ManageClient from "../ManageClient";
import ProfileImage from "../../../../assets/images/profile.svg";
import Loader from "../../../common/loader/Loader";
const ClientProfileCard = () => {
  const { clientId } = useParams();
  // get user store value
  const user = useSelector((state) => state.user);

  const { userDetail } = user;
  const admin = useSelector((state) => state.admin);
  const { adminDetail } = admin;
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const {
    isRecordUpdated,
    error: apiError,
    isLoader,
  } = useSelector((state) => state.clients);

  const [clientDetail, setClientDetail] = useState(null);
  const [copied, setCopied] = useState(false);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getClientByClientId({ clientId })).then(({ payload }) => {
      if (payload?.success) {
        setClientDetail(payload.data);
      }
    });
  }, []);

  useEffect(() => {
    if (isRecordUpdated) {
      dispatch(getClientByClientId({ clientId })).then(({ payload }) =>
        setClientDetail(payload.data)
      );
    }
  }, [isRecordUpdated]);

  const hideHandle = () => {
    setModalShow(false);
  };

  return (
    <>
      <ManageClient
        show={modalShow}
        onHide={hideHandle}
        title={"Edit Admin"}
        selectClient={clientDetail}
        modalShow={modalShow}
        setModalShow={setModalShow}
        adminDetail={adminDetail}
      />
      <div className="d-flex justify-content-start align-content-center align-items-center py-2 my-2">
        <h1
          className="title text-secondary"
          style={{ cursor: "pointer" }}
          onClick={() => navigate(`/`)}
        >
          Manage Admin
        </h1>
        <ChevronRight className="arrowRight" />
        <h1 className="title text-primary mt-1">Admin Detail</h1>
      </div>
      {apiError && (
        <Alert variant={"danger"}>
          {apiError?.message || "Access denied! Please try again"}
        </Alert>
      )}
      {isLoader && <Loader />}
      <div className="block">
        <Button
          className="btn-info"
          href="#"
          style={{ float: "right", color: "white" }}
          onClick={() => setModalShow(true)}
        >
          Edit Profile
        </Button>
      </div>
      <div className=" rowBoxDetail d-flex flex-wrap md-flex-row">
        <div className="p-4 mw-25">
          {clientDetail?.logo ? (
            <Image
              className="profileimg"
              src={clientDetail?.logo}
              alt=""
              style={{
                maxWidth: 160,
                maxHeight: 80,
                overflow: "hidden",
                borderWidth: 3,
                borderColor: "red",
              }}
            />
          ) : (
            <Image
              className="profileimg"
              src={ProfileImage}
              height="87"
              alt=""
            />
          )}
        </div>
        <div className="w-75">
          <Row>
            <Col xs={4}>
              {" "}
              <h2 className="objKey">Admin Organization :</h2>
            </Col>
            <Col xs={8}>
              <h2 className="objValue px-4">{clientDetail?.clientName}</h2>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              {" "}
              <h2 className="objKey">Admin Short Name :</h2>
            </Col>
            <Col xs={8}>
              <h2 className="objValue px-4">{clientDetail?.clientShortName}</h2>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              {" "}
              <h2 className="objKey">Admin Contact Name :</h2>
            </Col>
            <Col xs={8}>
              <h2 className="objValue px-4">{clientDetail?.contactName}</h2>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              {" "}
              <h2 className="objKey">Admin Email :</h2>
            </Col>
            <Col xs={8}>
              <h2 className="objValue px-4">{clientDetail?.clientEmail}</h2>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              {" "}
              <h2 className="objKey">Admin Status :</h2>
            </Col>
            <Col xs={8}>
              <h2 className="objValue px-4">
                {" "}
                {clientDetail?.isActivated ? (
                  clientDetail?.status === "Active" ? (
                    <span style={{ color: "#10940D", fontWeight: 500 }}>
                      Active
                    </span>
                  ) : (
                    <span style={{ color: "red" }}>Inactive</span>
                  )
                ) : (
                  <span style={{ color: "#F8A80C" }}>Pending</span>
                )}
              </h2>
            </Col>
          </Row>
        </div>
      </div>
      <div className=" mx-auto d-flex flex-wrap md-flex-row  justify-content-around shadow p-4 mb-5 bg-white rounded">
        <div className="publicUrlTitle font-weight-bolder">
          Your Public Url:
        </div>
        <div className="publicUrl font-weight-bolder">
          https://ccdguides.com/client/{clientDetail?.clientShortName}
        </div>
        <CopyToClipboard
          text={`https://ccdguides.com/client/${clientDetail?.clientShortName}`}
          onCopy={() => setCopied({ copied: true })}
        >
          <Button className="btn-info">Copy</Button>
        </CopyToClipboard>
        <p>{copied ? <span style={{ color: "green" }}>Copied.</span> : null}</p>
        <Button
          className="btn-primary"
          href="#"
          onClick={() =>
            window.open(
              `https://ccdguides.com/client/${clientDetail?.clientShortName}`
            )
          }
        >
          Open Link
        </Button>
      </div>
    </>
  );
};

export default ClientProfileCard;
